import * as React from 'react';


const UserSideNav: React.FC = (props) => {
  return (
    <div className='user-side-nav'>
      <div className='upper-section'>
        <div className='header-image-container'>
          <img src={process.env.PUBLIC_URL + '/logo512.png'} alt="BackOffice Logo" />
        </div>
      </div>
    </div>
  );
};

export default UserSideNav;
